import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const maxVisibleButtons = 2;
  let startPage = currentPage - 1;
  let endPage = currentPage + maxVisibleButtons - 1;

  if (startPage < 1) {
    startPage = 1;
    endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);
  } else if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisibleButtons + 1);
  }

  const pageNumbers = Array.from(
    { length: endPage - startPage + 1 },
    (_, index) => startPage + index
  );

  const handleClick = (pageNumber) => {
    onPageChange(pageNumber);
  };
  return (
    <div>
      {/* Botón de "Anterior" */}
      {currentPage > 1 && (
        <button
          onClick={() => handleClick(currentPage - 1)}
          className="border border-clvblue hover:border-[0px] hover:bg-clvblue hover:text-white font-bold py-1 px-2 mr-1 md:mr-2 rounded-full"
        >
          Prev.
        </button>
      )}

      {pageNumbers.map((pageNumber) => {
        return (
          <button
            key={pageNumber}
            onClick={() => handleClick(pageNumber)}
            disabled={pageNumber === currentPage}
            className={`border border-clvblue hover:border-[0px] ${pageNumber === currentPage ? 'bg-clvblue text-white' : ''} hover:bg-clvblue hover:text-white font-bold py-1 px-2 mr-1 md:mr-2 rounded-full`}
          >
            {pageNumber}
          </button>
        );
      })}

      {/* Botón de "Siguiente" */}
      {currentPage < totalPages && (
        <button
          onClick={() => handleClick(currentPage + 1)}
          className="border border-clvblue hover:border-[0px] hover:bg-clvblue hover:text-white font-bold py-1 px-2 mr-1 md:mr-2 rounded-full"
        >
          Sig.{" "}
        </button>
      )}
    </div>
  );
};

export default Pagination;
